import * as moment from 'moment';
import { QuizQuestion } from './quizQuestion';

export class Quiz {
    id: number;
    name: string;
    questions: QuizQuestion[];
    updated_at: moment.Moment;
    created_at: moment.Moment;
    constructor(quiz?) {
        if (quiz) {
            this.id = quiz.id;
            this.name = quiz.name;

            let questionArray=[];
            quiz.questions.forEach(question=>{
                questionArray.push(new QuizQuestion(question));
            })
            this.questions = questionArray;
            
            this.created_at = moment(quiz.created_at);
            this.updated_at = moment(quiz.updated_at);
        }
    }
}
